import React, { useState } from "react";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import StoreIcon from '@mui/icons-material/Store';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CloseIcon from '@mui/icons-material/Close';

const userTypes = [
  { type: "business user", label: "Store Management", icon: StoreIcon },
  { type: "delivery user", label: "Delivery Management", icon: LocalShippingIcon },
];

function UserTypeSelection({ onClose, handleUser }) {
  const [selectedType, setSelectedType] = useState(null);

  const handleClick = (type) => setSelectedType(type);

  return (
    <div className="relative p-6 sm:py-20 sm:px-8 overflow-y-auto max-h-[90vh]">
      <button
        className="absolute top-4 right-4 text-gray-600 hover:text-black"
        onClick={onClose}
        aria-label="Close"
      >
        <CloseIcon />
      </button>
      <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
        {userTypes.map(({ type, label, icon: Icon }) => (
          <CustomButton
            key={type}
            onClick={() => handleClick(type)}
            customeClass={`w-full sm:w-[298px] h-[180px] sm:h-[211px] custom-shadow-button ${
              selectedType === type ? "selected-button" : "primary-custom-button"
            }`}
          >
            <div className="flex flex-col items-center justify-center text-center">
              <Icon sx={{ height: "64px", width: "64px" }} />
              <div className="mt-2 text-sm sm:text-base">{label}</div>
            </div>
          </CustomButton>
        ))}
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row justify-center items-center mt-12 gap-3">
        <CustomButton
          onClick={onClose}
          customeClass="primary-custom-button w-full sm:w-[150px] h-[40px]"
        >
          Cancel
        </CustomButton>
        <CustomButton
          onClick={() => handleUser(selectedType)}
           customeClass={`gradient-button w-full sm:w-[150px] h-[40px] ${
    !selectedType ? "opacity-60 cursor-not-allowed" : ""
  }`}
          disabled={!selectedType}
        >
          Apply
        </CustomButton>
      </div>
    </div>
  );
}

export default UserTypeSelection;
